import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { payResult } from '../services/index';
import { getBrowser } from '@/utils/ua';
export default {
  data: function data() {
    var _this$$route$query = this.$route.query,
        _this$$route$query$me = _this$$route$query.merchant_id,
        merchant_id = _this$$route$query$me === void 0 ? '' : _this$$route$query$me,
        _this$$route$query$ou = _this$$route$query.out_order_no,
        out_order_no = _this$$route$query$ou === void 0 ? '' : _this$$route$query$ou,
        _this$$route$query$sc = _this$$route$query.scene,
        scene = _this$$route$query$sc === void 0 ? '' : _this$$route$query$sc;
    return {
      merchant_id: merchant_id,
      out_order_no: out_order_no,
      scene: scene,
      resInfo: '',
      isShowError: false
    };
  },
  created: function created() {
    this.getPayResult();
  },
  methods: {
    getPayResult: function () {
      var _getPayResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var payInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return payResult({
                  merchant_id: this.merchant_id,
                  out_order_no: this.out_order_no
                });

              case 2:
                payInfo = _context.sent;
                this.resInfo = payInfo;

                if (payInfo.result === 1) {
                  this.isShowError = false;
                } else {
                  this.isShowError = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPayResult() {
        return _getPayResult.apply(this, arguments);
      }

      return getPayResult;
    }(),
    closePage: function closePage() {
      var ua = getBrowser();

      if (ua === 'wechat') {
        WeixinJSBridge.call('closeWindow'); // eslint-disable-line
      } else if (ua === 'alipay') {
        AlipayJSBridge.call('closeWebview'); // eslint-disable-line
      }
    }
  }
};